import { Theme } from '@mui/material/styles'
import makeStyles from '@mui/styles/makeStyles'

export default makeStyles((theme: Theme) => ({
  inputContainer: {
    width: '100%'
  },

  inputField: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,

    '& > .MuiFormGroup-root': {
      flexGrow: 1,

      '& > .MuiFormControlLabel-root': {
        flex: '1 1 auto',
        marginLeft: 0,
        marginRight: 8
      }
    },

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },

  checkbox: {
    marginLeft: '8px',
    color: theme.colors.gray14,
    padding: '4px'
  },

  selectField: {
    display: 'flex',
    flexDirection: 'row',
    '& > .MuiGrid-root': {
      '& > .MuiInput-root': {
        display: 'flex',
        borderStyle: 'solid',
        borderWidth: 1,
        marginLeft: '0px',
        color: 'inherit',
        flexGrow: 1
      }
    }
  },

  autocompoleteField: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,

    '& > .MuiAutocomplete-root': {
      display: 'flex',
      borderStyle: 'solid',
      borderWidth: 1,
      marginLeft: '0px',
      color: 'inherit',
      flexGrow: 1,

      '& > .MuiFormControl-root': {
        flexDirection: 'row'
      }
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },

  inputRootAutocomplete: {
    paddingLeft: 10
  },

  select: {
    display: 'flex',
    paddingLeft: 10
  },

  selectError: {
    '& > .MuiGrid-root': {
      '& > .MuiInputBase-root': {
        borderColor: 'red'
      }
    }
  },

  inputSelect: {
    display: 'flex'
  },

  inputLabel: {
    display: 'flex',
    width: 200,
    alignSelf: 'center',

    [theme.breakpoints.down('md')]: {
      alignSelf: 'flex-start'
    }
  },
  inputRoot: {
    display: 'flex',
    borderStyle: 'solid',
    borderWidth: 1,
    marginLeft: '0px',
    color: 'inherit',
    flexGrow: 1
  },
  errorLabel: {
    display: 'flex',
    fontSize: theme.typography.subtitle2.fontSize,
    color: theme.palette.warning.dark,
    marginBottom: '-20px'
  },
  inputRootError: {
    borderColor: 'red'
  },
  inputLabelError: {
    color: 'red'
  },
  inputInput: {
    padding: theme.spacing(1, 7, 1, 1),
    transition: theme.transitions.create('width'),
    width: '100%!important',
    [theme.breakpoints.up('md')]: {
      width: 200
    }
  },
  fieldSet: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    borderWidth: 1,
    borderColor: theme.palette.primary.light,
    marginBottom: 10,
    padding: 20,
    gap: '20px 5px',
    height: '100%',
    backgroundColor: '#fff',
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.light,
    borderStyle: 'solid'
  },
  legend: {
    display: 'flex',
    width: '25%',
    padding: theme.spacing(0.2, 1, 0.2, 1),
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    borderWidth: 1,
    borderStyle: 'solid',
    minHeight: 30
  },
  legendLabel: {
    display: 'flex',
    flexGrow: 1,
    alignSelf: 'center'
  },
  wrapperCheckbox: {
    display: 'flex',
    alignItems: 'flex-end',
    height: '60px'
  }
}))
